/* eslint-disable no-inline-styles/no-inline-styles */
import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Button, Container, Row } from 'reactstrap';
import NavbarComponent from '../../Components/Header/Navbar';
import { APIClient } from '../../helpers/ApiHeleps';
import { toast } from 'react-toastify';
import { getTenantConfig, guid } from '../../Components/Common/Util';
import { getPathAfterDomain } from '../Dashboard/utils';

const RecaptchaComponent = () => {
    const api = new APIClient();
    const captchRef = useRef(null);
    const history = useHistory();
    const location = useLocation();
    const [token, setToken] = useState();
    const [loading, setLoading] = useState(false);
    const [capturedGuId, setCapturedGuId] = useState();
    const tenantConfig = getTenantConfig(location?.pathname);

    const initiateApiToken = {
        token: `Basic ${tenantConfig.REACT_APP_INITIATE_AUTH_TOKEN}`,
        apiKey: `${tenantConfig.REACT_APP_INITIATE_API_KEY}`
    };
    // const trackApiToken = {
    //     token: 'Basic eyJVc2VybmFtZSI6ImdnaC50cmFjayIsIlBhc3N3b3JkIjoiR0dIQFRyYWNrMTIzIn0=',
    //     apiKey: '17bb9b33-8d87-4421-b674-72c22531c7b9'
    // };
    const initialteApiPayLoad = {
        placeholderData: {},
        defaultLanguage: 'en',
        memberId: guid(),
        assessmentInternalId: tenantConfig.REACT_APP_ASSESSMENT_ID
    };

    const trackApiObj = {
        url: 'universal/track',
        method: 'GET',
        token: `Basic ${tenantConfig.REACT_APP_TRACK_AUTH_TOKEN}`,
        apiKey: `${tenantConfig.REACT_APP_TRACT_API_KEY}`,
        customEndPointUrl: process.env.REACT_APP_API_BASE_URL
    };
    const trackApiCall = async () => {
        try {
            let resp = await api.customApiCall(trackApiObj, setCapturedGuId);
            if (!resp?.data?.isSuccess) {
                toast.error('Track api is failing.');
                return;
            }
        } catch (err) {
            toast.error('Something went wrong please try again.');
        }
    };
    useEffect(() => {
        trackApiCall();
    }, []);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?hl=en';
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            // Initialize reCAPTCHA or perform other actions after the script has loaded
            if (window.grecaptcha) {
                window.grecaptcha.ready(() => {
                    window.grecaptcha.render('recaptcha-container', {
                        sitekey: process.env.REACT_APP_RECAPCHA_SITE_KEY,
                        callback: (response) => {
                            response && setToken(response);
                        }
                    });
                });
            }
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const handleSubmit = async () => {
        if (!token) {
            toast.error('Please verify with reCAPTCHA.');
            return;
        }
        setLoading(true);
        try {
            const resp = await api.create('initiate', initiateApiToken, initialteApiPayLoad, '', capturedGuId);
            if (resp?.data?.isSuccess && resp?.data?.data?.length) {
                // location?.pathname?.replace('/qrcode/marriot', '');
                let url = getPathAfterDomain(resp?.data?.data);
                setLoading(false);
                history.push(url);
            } else if (!resp?.data?.isSuccess && resp?.data?.errorMessage?.length) {
                toast.error(resp?.data?.errorMessage?.length ? resp?.data?.errorMessage?.[0] : 'Initiate api is failing please try again');
                setLoading(false);
            }
        } catch (err) {
            toast.error('Something went wrong please try again.');
            setLoading(false);
        }
    };

    return (
        <React.Fragment>
            <NavbarComponent language={undefined} languagesList={undefined} changeLanguages={undefined} />
            <Container>
                <Row className="justify-content-center page-content">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                        <div id="recaptcha-container"></div>
                        {/* <ReCAPTCHA
                            sitekey={process.env.REACT_APP_RECAPCHA_SITE_KEY}
                            ref={captchRef}
                            className="mt-2"
                            onChange={(e) => {
                                e && setToken(e);
                            }}
                        /> */}
                        <Button color="success" onClick={handleSubmit} type="submit" className="my-2 " disabled={loading}>
                            {loading ? 'Loading' : 'Proceed'}
                        </Button>
                    </div>
                </Row>
            </Container>
        </React.Fragment>
    );
};

export default RecaptchaComponent;
